// extracted by mini-css-extract-plugin
export var standaloneTable = "_df-0";
export var standaloneTableWithBodyFill = "_df-1";
export var withExtraHeader = "_df-2";